// Career.js

import React from 'react';

const Career = () => {
  return (
    <div className="container mt-4">
    <div className="d-flex flex-column vh-100">
  
    <div className="container flex-grow-1">
    <h2 className="text-center mb-4">Career page</h2>
     <p className="text-center mb-4">Page development in progress. Coming soon!</p>
    </div>
   
  </div>
  </div>
  );
};

export default Career;
